<template>
  <keep-alive>
    <router-view/>
  </keep-alive>
</template>

<script>
export default {
  name: "SystemLayout",
  data() {
    return {};
  },
  components: {},
  created() {
  },
  mounted() {
  },
  computed: {},
  watch: {},
  methods: {},
};
</script>

<style scoped>
</style>
